export default __webpack_public_path__ + "static/media/course-1.b7190898.jpeg";